// extracted by mini-css-extract-plugin
module.exports = {"layoutLoaderContainer":"LayoutLoader__layoutLoaderContainer--32h","layoutLoaderText":"LayoutLoader__layoutLoaderText--1b7","navBarPresent":"LayoutLoader__navBarPresent--1Kc"};